import styles from '@/styles/About.module.css'
import Head from 'next/head'
import dynamic from 'next/dynamic'

const Italienska = dynamic(() => import('@/components/Italienska'))

const Page = () => {
  return (
    <main className={styles.main}>
      <Head>
        <title>La Bambi Restaurang - Italienska Pizzor Meny</title>
        <meta
          name='description'
          content='Upplev en smakexplosion av italienska pizzor, bakade i vår traditionella pizzaugn. Njut av tunna, krispiga pizzor med fyllningar som är gjorda med kärlek och passion. Här hittar du allt från klassiska pizzor som Cacciatore special, Crudo och Quattro Formaggi till mer experimentella pizzor med unika smaker. Varje pizza är bakad med passion och omsorg för att ge dig en smakupplevelse utöver det vanliga.'
        />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
      </Head>
      {/* <div className={styles.pizzaWrapper}>
        <h1 className={styles.pizzaTitle}></h1>
        <p className={styles.headerPara}>
          Alla pizzor innehåller tomatsås och ost
        </p>
      </div> */}
      <Italienska title='Alla italienska pizzor innehåller mozzarellaost och tomatsås' />
    </main>
  )
}

export default Page
